import { APP_TYPE, AppType } from '../common';

export const API_IDS = {
    CONFIG_PAYMENT_CONFIG: 'CONFIG_PAYMENT_CONFIG',
    USER_EMAIL_VERIFICATION_GENERATE_PIN: 'USER_EMAIL_VERIFICATION_GENERATE_PIN',
    USER_LOCATE_USER: 'USER_LOCATE_USER',
    USER_EMAIL_VERIFICATION_VERIFY_PIN: 'USER_EMAIL_VERIFICATION_VERIFY_PIN',
    USER_LOGIN_OTP: 'USER_LOGIN_OTP',
    USER_LOGIN_STEP_1: 'USER_LOGIN_STEP_1',
    USER_LOGIN_CREDENTIALS: 'USER_LOGIN_CREDENTIALS',
    USER_LOGIN_WITH_TOKEN: 'USER_LOGIN_WITH_TOKEN',
    USER_CHANGE_PASSWORD: 'USER_CHANGE_PASSWORD',
    USER_GENERATE_PIN: 'USER_GENERATE_PIN',
    USER_VERIFY_PIN: 'USER_VERIFY_PIN',
    USER_RESET_PASSWORD_STEP1: 'USER_RESET_PASSWORD_STEP1',
    USER_RESET_PASSWORD_STEP2: 'USER_RESET_PASSWORD_STEP2',
    USER_GENERATE_PIN_AUTHENTICATED_USER: 'USER_GENERATE_PIN_AUTHENTICATED_USER',
    USER_VERIFY_PIN_AUTHENITCATED_USER: 'USER_VERIFY_PIN_AUTHENITCATED_USER',
    USER_FORGOT_PASSWORD_GENERATE_PIN_BY_EMAIL: 'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_EMAIL',
    USER_FORGOT_PASSWORD_VERIFIY_BY_EMAIL: 'USER_FORGOT_PASSWORD_VERIFIY_BY_EMAIL',
    USER_FORGOT_PASSWORD_UPDATE_BY_EMAIL: 'USER_FORGOT_PASSWORD_UPDATE_BY_EMAIL',
    USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN: 'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN',
    USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN_NEW: 'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN_NEW',
    USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN: 'USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN',
    USER_FORGOT_PASSWORD_UPDATE_BY_MSISDN: 'USER_FORGOT_PASSWORD_UPDATE_BY_MSISDN',
    USER_SUBSCRIPTION_STATUS: 'USER_SUBSCRIPTION_STATUS',
    USER_SUBSCRIPTION_STATUS_NEW: 'USER_SUBSCRIPTION_STATUS_NEW',
    USER_UNSUBSCRIBE: 'USER_UNSUBSCRIBE',
    USER_TPAY_REDIRECT_SUBSCRIBE_NEW_USER: 'USER_TPAY_REDIRECT_SUBSCRIBE_NEW_USER',
    USER_TPAY_REDIRECT_SUBSCRIBE_EXISTING_USER: 'USER_TPAY_REDIRECT_SUBSCRIBE_EXISTING_USER',
    USER_PARTNER_ACTIVATE_LINK: 'USER_PARTNER_ACTIVATE_LINK',
    USER_VERIFY_USER: 'USER_VERIFY_USER',
    VERIFY_EMAIL: 'VERIFY_EMAIL',
    CONTENT_CHANNELS_MINI_EPG: 'CONTENT_CHANNELS_MINI_EPG',
    CONTENT_CHANNELS_ARRIS_STB: 'CONTENT_CHANNELS_ARRIS_STB',
    CONTENT_CHANNELS: 'CONTENT_CHANNELS',
    CONTENT_CHANNELS_KIDS: 'CONTENT_CHANNELS_KIDS',
    CONTENT_CHANNELS_CDN_SCHEDULE: 'CONTENT_CHANNELS_CDN_SCHEDULE',
    DEVICE_ADD: 'DEVICE_ADD',
    DEVICE_DELETE: 'DEVICE_DELETE',
    QR_GENERATE_CODE: 'QR_GENERATE_CODE',
    QR_AUTHENTICATE_CODE: 'QR_AUTHENTICATE_CODE',
    QR_CODE_LOGIN: 'QR_CODE_LOGIN',
    QR_CODE_PAIRING: 'QR_CODE_PAIRING',
    QR_CODE_LINK: 'QR_CODE_LINK',
    ENTITLEMENT_QITAF_GENERATE_OTP: 'ENTITLEMENT_QITAF_GENERATE_OTP',
    ENTITLEMENT_QITAF_TVOD_GENERATE_OTP: 'ENTITLEMENT_QITAF_TVOD_GENERATE_OTP',
    ENTITLEMENT_QITAF_VERIFY_OTP: 'ENTITLEMENT_QITAF_VERIFY_OTP',
    ENTITLEMENT_QITAF_TVOD_VERIFY_OTP: 'ENTITLEMENT_QITAF_TVOD_VERIFY_OTP',
    ENTITLEMENT_ALLOWED_COUNTRIES: 'ENTITLEMENT_ALLOWED_COUNTRIES',
    ENTITLEMENT_AVAILABLE_PACKAGES: 'ENTITLEMENT_AVAILABLE_PACKAGES',
    ENTITLEMENT_TVODS: 'ENTITLEMENT_TVODS',
    ENTITLEMENT_TVOD_PRICING_TEMPLATE: 'ENTITLEMENT_TVOD_PRICING_TEMPLATE',
    ENTITLEMENT_ALL: 'ENTITLEMENT_ALL',
    ENTITLEMENT_ALL_SUBSCRIPTION_TIERS: 'ENTITLEMENT_ALL_SUBSCRIPTION_TIERS',
    ENTITLEMENT_ALL_SUBSCRIPTION_TIERS_V2: 'ENTITLEMENT_ALL_SUBSCRIPTION_TIERS_V2',
    ENTITLEMENT_CHANNELS: 'ENTITLEMENT_CHANNELS',
    ENTITLEMENT_PROFILE_EPG_CHANNELS: 'ENTITLEMENT_PROFILE_EPG_CHANNELS',
    ENTITLEMENT_SUBSCRIBE: 'ENTITLEMENT_SUBSCRIBE',
    ENTITLEMENT_TVOD_PURCHASE: 'ENTITLEMENT_TVOD_PURCHASE',
    ENTITLEMENT_TVOD_OTP_GENERATE: 'ENTITLEMENT_TVOD_OTP_GENERATE',
    ENTITLEMENT_TVOD_OTP_VERIFY: 'ENTITLEMENT_TVOD_OTP_VERIFY',
    ENTITLEMENT_PAYMENT_SWITCH_GENERATE_PIN: 'ENTITLEMENT_PAYMENT_SWITCH_GENERATE_PIN',
    ENTITLEMENT_PAYMENT_SWITCH_VERIFY_PIN: 'ENTITLEMENT_PAYMENT_SWITCH_VERIFY_PIN',
    ENTITLEMENT_NETFLIX_FORGOT_ACCOUNT: 'ENTITLEMENT_NETFLIX_FORGOT_ACCOUNT',
    ENTITLEMENT_AMAZON_ACTIVTION_LINK: 'ENTITLEMENT_AMAZON_ACTIVTION_LINK',
    ENTITLEMENT_AMAZON_ACCOUNT_RECOVERY: 'ENTITLEMENT_AMAZON_ACCOUNT_RECOVERY',
    MPX_ALL_VOD_FEED: 'MPX_ALL_VOD_FEED',
    PROFILE_CUD: 'PROFILE_CUD',
    PROFILE_LIST: 'PROFILE_LIST',
    PROFILE_SWITCH: 'PROFILE_SWITCH',
    PROFILE_UPDATE: 'PROFILE_UPDATE',
    PROFILE_DELETE: 'PROFILE_DELETE',
    PROFILE_ADD: 'PROFILE_ADD',
    PROFILE_FAVORITE: 'PROFILE_FAVORITE',
    PROFILE_WATCHLIST_VOD: 'PROFILE_WATCHLIST_VOD',
    PROFILE_WATCHLIST_LINEAR: 'PROFILE_WATCHLIST_LINEAR',
    PROFILE_GET_WATCHLIST: 'PROFILE_GET_WATCHLIST',
    PROFILE_CREATE_PARENTAL_PIN: 'PROFILE_CREATE_PARENTAL_PIN',
    PROFILE_VALIDATE_PARENTAL_PIN: 'PROFILE_VALIDATE_PARENTAL_PIN',
    PROFILE_GET_PARENTAL_PIN: 'PROFILE_GET_PARENTAL_PIN',
    PROFILE_UPDATE_PARENTAL_PIN: 'PROFILE_UPDATE_PARENTAL_PIN',
    PROFILE_RESET_PARENTAL_PIN_OTP: 'PROFILE_RESET_PARENTAL_PIN_OTP',
    PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY: 'PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY',
    PROFILE_RESET_PARENTAL_PIN_WITH_OTP: 'PROFILE_RESET_PARENTAL_PIN_WITH_OTP',
    PROFILE_VALIDATE_PASSWORD: 'PROFILE_VALIDATE_PASSWORD',
    INTERNAL_VERIFY_USER: 'INTERNAL_VERIFY_USER',
    ZENDESK_SUBMIT_FORM: 'ZENDESK_SUBMIT_FORM',
    CMS_CONFIGURATION: 'CMS_CONFIGURATION',
    CMS_LANGUAGE: 'CMS_LANGUAGE',
    CMS_SCREEN: 'CMS_SCREEN',
    SLP_API_FORM_SIGNATURE: 'SLP_API_FORM_SIGNATURE',
    SLP_API_LOGIN_VERIFY: 'SLP_API_LOGIN_VERIFY',
    SLP_API_LOGIN_CREDENTIALS: 'SLP_API_LOGIN_CREDENTIALS',
    SLP_API_LOGIN_OTP: 'SLP_API_LOGIN_OTP',
    ENTITLEMENT_ADDON_PURCHASE: 'ENTITLEMENT_ADDON_PURCHASE',
    SLP_API_FORGOT_PASSWORD_SEND_OTP: 'SLP_API_FORGOT_PASSWORD_SEND_OTP',
    SLP_API_FORGOT_PASSWORD_RESEND_OTP: 'SLP_API_FORGOT_PASSWORD_RESEND_OTP',
    SLP_API_FORGOT_PASSWORD_VERIFY_OTP: 'SLP_API_FORGOT_PASSWORD_VERIFY_OTP',
    SLP_API_FORGOT_PASSWORD_RESET: 'SLP_API_FORGOT_PASSWORD_RESET',
    POPCORN_API_FORGOT_PIN: 'POPCORN_API_FORGOT_PIN',
    SLP_API_VERIFY_QR_CODE: 'SLP_API_VERIFY_QR_CODE',
    USER_CDN_API_USER_REVISION: 'USER_CDN_API_USER_REVISION',
    AUTO_LOGIN: 'AUTO_LOGIN',
    AUTH_REFRESH_TOKEN: 'AUTH_REFRESH_TOKEN',
    REMINDER_API_SET_REMINDER: 'REMINDER_API_SET_REMINDER',
    REMINDER_API_UNSET_REMINDER: 'REMINDER_API_UNSET_REMINDER',
    REMINDER_VOD_API_LIST_REMINDER: 'REMINDER_VOD_API_LIST_REMINDER',
    REMINDER_LINIER_API_LIST_REMINDER: 'REMINDER_LINIER_API_LIST_REMINDER',
    REMINDER_PPV_API_LIST_REMINDER: 'REMINDER_PPV_API_LIST_REMINDER',
    REMINDER_LIST: 'REMINDER_LIST',
    SLP_API_AMAZON_ACTIVATE: 'SLP_API_AMAZON_ACTIVATE',
    ZENDESK_JWT_TOKEN: 'ZENDESK_JWT_TOKEN',
    ZENDESK_JWT_TOKEN_CLASSIC: 'ZENDESK_JWT_TOKEN_CLASSIC',
    DEVICE_PAIRING: 'DEVICE_PAIRING',
    BOOKMARK_API: 'BOOKMARK_API',
    GEO_LOCATION_API_GET_MY_LOCATION: 'GEO_LOCATION_API_GET_MY_LOCATION',
    POPCORN_API_GET_ALL_PROMOTIONS: 'POPCORN_API_GET_ALL_PROMOTIONS',
    POPCORN_API_GET_ALL_REWIND: 'POPCORN_API_GET_ALL_REWIND',
    DISCOUNT_API_VALIDATE_GIFT_CARD: 'DISCOUNT_API_VALIDATE_GIFT_CARD',
    DISCOUNT_API_SUBSCRIBE_BY_GIFT_CARD: 'DISCOUNT_API_SUBSCRIBE_BY_GIFT_CARD',
    DISCOUNT_API_RESUBSCRIBE_BY_GIFT_CARD: 'DISCOUNT_API_RESUBSCRIBE_BY_GIFT_CARD',
    DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE: 'DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE',
    DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE_VERIFY: 'DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE_VERIFY',
    CHANNELS_HISTORY: 'CHANNELS_HISTORY',
    CHANNEL_INFO: 'CHANNEL_INFO',
    SERIES_HISTORY: 'SERIES_HISTORY',
    PROFILE_WATCH_HISTORY: 'PROFILE_WATCH_HISTORY',
    THINK_ANALYTICS_API_GET_VOD_LIST: 'THINK_ANALYTICS_API_GET_VOD_LIST',
    GATEWAY_CONFIGURATION: 'GATEWAY_CONFIGURATION',
    GATEWAY_LANGUAGE_EN: 'GATEWAY_LANGUAGE_EN',
    GATEWAY_LANGUAGE_AR: 'GATEWAY_LANGUAGE_AR',
    GATEWAY_SCREEN: 'GATEWAY_SCREEN',
    THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED: 'THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED',
    THINK_ANALYTICS_API_GET_RELATED: 'THINK_ANALYTICS_API_GET_RELATED',
    THINK_ANALYTICS_API_GET_RELATED_OTHERS: 'THINK_ANALYTICS_API_GET_RELATED_OTHERS',
    BOOKMARK_API_WATCH_AGAIN: 'BOOKMARK_API_WATCH_AGAIN',
    THINK_ANALYTICS_API_SEARCH_SUGGESTIONS: 'THINK_ANALYTICS_API_SEARCH_SUGGESTIONS',
    THINK_ANALYTICS_API_SEARCH_PA: 'THINK_ANALYTICS_API_SEARCH_PA',
    CONTENT_LIKE_DISLIKE_RATING: 'CONTENT_LIKE_DISLIKE_RATING',
    SLP_COUNTRY_CONFIGS: 'SLP_COUNTRY_CONFIGS',
    RESUBSCRIBE_OTP_SEND: 'RESUBSCRIBE_OTP_SEND',
    RESUBSCRIBE_OTP_VERIFY: 'RESUBSCRIBE_OTP_VERIFY',
    PAYMENT_SWITCH_GENERATE: 'PAYMENT_SWITCH_GENERATE',
    PAYMENT_SWITCH_VERIFY: 'PAYMENT_SWITCH_VERIFY',
    RESUBSCRIBE_CREDIT_CARD: 'RESUBSCRIBE_CREDIT_CARD',
    SLP_BUNDLE_SAVE: 'SLP_BUNDLE_SAVE',
    SLP_BUNDLE_SAVE_INFO: 'SLP_BUNDLE_SAVE_INFO',
    SLP_BUNDLE_SAVE_RULES: 'SLP_BUNDLE_SAVE_RULES',
    ACTIVE_SUB_VOUCHER: 'ACTIVE_SUB_VOUCHER',
    SLP_BOLT_SUBSCRIPTION: 'SLP_BOLT_SUBSCRIPTION',
    SLP_BOLT_SUBSCRIPTION_TWO_STEPS: 'SLP_BOLT_SUBSCRIPTION_TWO_STEPS',
    SLP_BOLT_VERIFICATION_TWO_STEPS: 'SLP_BOLT_VERIFICATION_TWO_STEPS',
    SLP_QITAF_GENERATE_OTP: 'SLP_QITAF_GENERATE_OTP',
    SLP_QITAF_VERIFY_OTP: 'SLP_QITAF_VERIFY_OTP',
    LEARN_ACTION_SET_PREFERENCES: 'LEARN_ACTION_SET_PREFERENCES',
    SEARCH_ACTION_CLICK: 'SEARCH_ACTION_CLICK',
    LEARN_EVENTS: 'LEARN_EVENTS',
    THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE: 'THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE',
    SLP_USER_REGISTRATION: 'SLP_USER_REGISTRATION',
    SLP_USER_REGISTRATION_GENERATE_PIN: 'SLP_USER_REGISTRATION_GENERATE_PIN',
    SLP_USER_REGISTRATION_VERIFY_PIN: 'SLP_USER_REGISTRATION_VERIFY_PIN',
    NOTIFICATIONS_VALIDATE_VOC_TOKEN: 'NOTIFICATIONS_VALIDATE_VOC_TOKEN',
    SLP_LEGACY_CC_MIGRATE: 'SLP_LEGACY_CC_MIGRATE',
    SLP_LEGACY_DCB_MIGRATE_GENERATE: 'SLP_LEGACY_DCB_MIGRATE_GENERATE',
    SLP_LEGACY_DCB_MIGRATE_VERIFY: 'SLP_LEGACY_DCB_MIGRATE_VERIFY',
    GET_PROVIDERS: 'GET_PROVIDERS',
    GET_FOOTER_MENU_CONTENT: 'GET_FOOTER_MENU_CONTENT',
    GET_ITEM_BY_ID: 'GET_ITEM_BY_ID',
    GET_CAST_CREW: 'GET_CAST_CREW',
    GET_ALL_SEASONS: 'GET_ALL_SEASONS',
    GET_ALL_EPISODES: 'GET_ALL_EPISODES',
    USER_CONSENT_API: 'USER_CONSENT_API',
    GET_HEADER_MENU_CONTENT: 'GET_HEADER_MENU_CONTENT',
    RBO_RESUB: 'RBO_RESUB',
    RBO_RESUB_VERIFY: 'RBO_RESUB_VERIFY',
    MPX_BIOGRAPHY: 'MPX_BIOGRAPHY',
    MPX_FILMOGRAPHY: 'MPX_FILMOGRAPHY',
    CHANNELS: 'CHANNELS',
    POPCORN_GET_ALL_REWIND_MOVIES: 'POPCORN_GET_ALL_REWIND_MOVIES',
    CATCH_UP_EPISODE_LIST: 'CATCH_UP_EPISODE_LIST',
    MIXED_CATCH_UP_EPISODE_LIST: 'MIXED_CATCH_UP_EPISODE_LIST',
    CATCH_UP_CAROUSEL_LIST: 'CATCH_UP_CAROUSEL_LIST',
    MIXED_CATCH_UP_CAROUSEL_LIST: 'MIXED_CATCH_UP_CAROUSEL_LIST',
    MOODS_RECOMMENDATION: 'MOODS_RECOMMENDATION',
    STC_PLAY_GAMES: 'STC_PLAY_GAMES',
    THINK_ANALYTICS_API_GET_FEELING_LUCKY: 'THINK_ANALYTICS_API_GET_FEELING_LUCKY',
    MPX_GET_CHANNEL_CATEGORIES_API: 'MPX_GET_CHANNEL_CATEGORIES_API',
    MPX_GET_CHANNEL_LIST_BY_CATEGORY_API: 'MPX_GET_CHANNEL_LIST_BY_CATEGORY_API',
    THINK_ANALYTICS_MOOD_VOD_API: 'THINK_ANALYTICS_MOOD_VOD_API',
    MPX_GET_ALL_LIST: 'MPX_GET_ALL_LIST',
    STREAM_HARNESS_ACQUIRE_LOCK: 'STREAM_HARNESS_ACQUIRE_LOCK',
    STREAM_HARNESS_UNLOCK: 'STREAM_HARNESS_UNLOCK',
    STREAM_HARNESS_UNLOCK_J21: 'STREAM_HARNESS_UNLOCK_J21',
    LOGOUT_API: 'LOGOUT_API',
    PPV_GET_EVENT_CONFIG: 'PPV_GET_EVENT_CONFIG',
    PPV_GET_COUNTRY_CONFIG: 'PPV_GET_COUNTRY_CONFIG',
    PPV_PURCHASE: 'PPV_PURCHASE',
    PPV_PURCHASE_GENERATE_PIN: 'PPV_PURCHASE_GENERATE_PIN',
    PPV_PURCHASE_VERIFY_PIN: 'PPV_PURCHASE_VERIFY_PIN',
    GET_PPV_FEED: 'GET_PPV_FEED',
    PROFILE_AVATER_LIST: 'PROFILE_AVATER_LIST',
    REWARD_API_GET_BADGES: 'REWARD_API_GET_BADGES',
    REWARD_API_GET_QUESTS: 'REWARD_API_GET_QUESTS',
    CAMPAIGN_GENERATE: 'CAMPAIGN_GENERATE',
    CAMPAIGN_VERIFY: 'CAMPAIGN_VERIFY',
    CHECK_USER: 'CHECK_USER',
    PPV_PURCHASE_PIN: 'PPV_PURCHASE_PIN',
    SUBSCRIPTION_VALIDATE_ACTIVATION_LINK: 'SUBSCRIPTION_VALIDATE_ACTIVATION_LINK',
    SUBSCRIPTION_DISNEY_GENERATE_OTP: 'SUBSCRIPTION_DISNEY_GENERATE_OTP',
    SUBSCRIPTION_DISNEY_VALIDATE_OTP: 'SUBSCRIPTION_DISNEY_VALIDATE_OTP',
    SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK: 'SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK',
    FORGET_PIN_RESEND: 'FORGET_PIN_RESEND',
    GET_CONTENT_RATING: 'GET_CONTENT_RATING',
    B2C_RESET_PASSWORD_GENERATE: 'B2C_RESET_PASSWORD_GENERATE',
    B2C_RESET_PASSWORD_VERIFY: 'B2C_RESET_PASSWORD_VERIFY',
    MPX_CONTENT_DETAILS: 'MPX_CONTENT_DETAILS',
} as const;

export type ApiId = (typeof API_IDS)[keyof typeof API_IDS];

export const getApiIdMap = (appType: AppType): Record<ApiId, string> => {
    switch (appType) {
        case APP_TYPE.WCP:
        case APP_TYPE.TV:
            return {
                ...API_ID_MAP,
                [API_IDS.GATEWAY_LANGUAGE_EN]: 'wcp_localization_en',
                [API_IDS.GATEWAY_LANGUAGE_AR]: 'wcp_localization_ar',
                [API_IDS.GATEWAY_SCREEN]: 'layout_gateway_screen',
                [API_IDS.THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED]: 'because_you_watch_ta',
                [API_IDS.GEO_LOCATION_API_GET_MY_LOCATION]: 'geo_location',
                [API_IDS.DEVICE_ADD]: 'add_device_j21',
                [API_IDS.DEVICE_DELETE]: 'remove_device_j21',
                [API_IDS.PROFILE_LIST]: 'get_profiles_v1',
                [API_IDS.PROFILE_DELETE]: 'delete_profile_v1',
                [API_IDS.PROFILE_ADD]: 'create_profile_v1',
                [API_IDS.PROFILE_UPDATE]: 'update_profile_v1',
                [API_IDS.PROFILE_SWITCH]: 'profile_switch_v3',
                [API_IDS.SLP_API_FORM_SIGNATURE]: 'SLP_API_FORM_SIGNATURE',
                [API_IDS.LEARN_ACTION_SET_PREFERENCES]: 'preferences_learning_action_ta',
                [API_IDS.POPCORN_API_GET_ALL_PROMOTIONS]: 'slider_promotions',
                [API_IDS.ENTITLEMENT_PROFILE_EPG_CHANNELS]: 'profile_egp_channels',
                [API_IDS.CONTENT_CHANNELS]: 'home_carousel_live-channel-streaming-now',
                [API_IDS.CONTENT_CHANNELS_KIDS]: 'home_carousel_live-kidsstreaming',
                [API_IDS.CONTENT_CHANNELS_CDN_SCHEDULE]: 'content_channels_schedules',
                [API_IDS.GET_PROVIDERS]: 'home_carousel_providers_v2',
                [API_IDS.POPCORN_API_GET_ALL_REWIND]: 'rewind_carousel_entertainment',
                [API_IDS.GET_FOOTER_MENU_CONTENT]: 'footer_menu',
                [API_IDS.ENTITLEMENT_TVOD_PRICING_TEMPLATE]: 'price_templates_api_j21',
                [API_IDS.PROFILE_WATCH_HISTORY]: 'kids_viewership_history',
                [API_IDS.THINK_ANALYTICS_API_SEARCH_PA]: 'pa_all_ta',
                [API_IDS.ENTITLEMENT_TVOD_OTP_GENERATE]: 'generate_otp_tvod_api_j21',
                [API_IDS.ENTITLEMENT_TVOD_OTP_VERIFY]: 'verify_otp_tvod_api_j21',
                [API_IDS.PROFILE_GET_WATCHLIST]: 'users_watchlist_v3',
                [API_IDS.GET_ITEM_BY_ID]: 'vod_all_feeds',
                [API_IDS.GET_CAST_CREW]: 'person',
                [API_IDS.GET_ALL_SEASONS]: 'all_seasons',
                [API_IDS.GET_ALL_EPISODES]: 'all_episodes',
                [API_IDS.CHANNELS_HISTORY]: 'recently_watched_live_tv',
                [API_IDS.CHANNEL_INFO]: 'home_carousel_live-channel',
                [API_IDS.USER_CONSENT_API]: 'get_consents',
                [API_IDS.GET_HEADER_MENU_CONTENT]: appType === APP_TYPE.TV ? 'layout_global_new' : 'header_menu',
                [API_IDS.THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE]: 'because_you_watch_last_in_two_ta',
                [API_IDS.THINK_ANALYTICS_API_SEARCH_SUGGESTIONS]: 'suggestive_search_ta',
                [API_IDS.PROFILE_CREATE_PARENTAL_PIN]: 'create_parental_lock_v1',
                [API_IDS.PROFILE_VALIDATE_PARENTAL_PIN]: 'validate_parental_lock_v1',
                [API_IDS.THINK_ANALYTICS_API_GET_RELATED]: 'recommend_related_details',
                [API_IDS.THINK_ANALYTICS_API_GET_RELATED_OTHERS]: 'recommend_related_others_details',
                [API_IDS.PROFILE_UPDATE_PARENTAL_PIN]: 'reset_parental_lock_v1',
                [API_IDS.PROFILE_RESET_PARENTAL_PIN_OTP]: 'reset_parental_lock_otp_v1',
                [API_IDS.PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY]: 'reset_parental_lock_otp_verify_v1',
                [API_IDS.PROFILE_RESET_PARENTAL_PIN_WITH_OTP]: 'reset_parental_lock_with_otp_v1',
                [API_IDS.PROFILE_GET_PARENTAL_PIN]: 'view_parental_lock_v1',
                [API_IDS.PROFILE_VALIDATE_PASSWORD]: 'profile_validate_password',
                [API_IDS.REMINDER_API_SET_REMINDER]: 'user_reminder_set_v2',
                [API_IDS.REMINDER_API_UNSET_REMINDER]: 'user_reminder_unset_v2',
                [API_IDS.REMINDER_VOD_API_LIST_REMINDER]: 'user_vods_reminder_list_v3',
                [API_IDS.REMINDER_LINIER_API_LIST_REMINDER]: 'user_linears_reminder_list_v3',
                [API_IDS.REMINDER_PPV_API_LIST_REMINDER]: 'user_ppvs_reminder_list_v3',
                [API_IDS.REMINDER_LIST]: 'user_reminder_list_v3',
                [API_IDS.PROFILE_WATCHLIST_VOD]: 'users_watchlist_vod_v3',
                [API_IDS.PROFILE_WATCHLIST_LINEAR]: 'users_watchlist_linear_v3',
                [API_IDS.CONTENT_LIKE_DISLIKE_RATING]: 'add_content_rating_ta',
                [API_IDS.MPX_BIOGRAPHY]: 'biography_all',
                [API_IDS.MPX_FILMOGRAPHY]: 'filmography',
                [API_IDS.ENTITLEMENT_TVOD_PURCHASE]: 'users_onetime_purchase_j21',
                [API_IDS.ENTITLEMENT_QITAF_TVOD_GENERATE_OTP]: 'tvod_qitaf_otp_generate',
                [API_IDS.ENTITLEMENT_QITAF_TVOD_VERIFY_OTP]: 'tvod_qitaf_otp_verify',
                [API_IDS.CHANNELS]: 'content_channels',
                [API_IDS.POPCORN_GET_ALL_REWIND_MOVIES]: 'rewind_carousel_movies',
                [API_IDS.ENTITLEMENT_ALL_SUBSCRIPTION_TIERS]: 'new_subscriptions_tiers_j21',
                [API_IDS.AUTH_REFRESH_TOKEN]: 'nest_auth_refresh_token',
                [API_IDS.ENTITLEMENT_ALL_SUBSCRIPTION_TIERS_V2]: 'new_subscriptions_tiers_j21',
                [API_IDS.ZENDESK_JWT_TOKEN_CLASSIC]: 'zendesk_jwt_token_classic_api',
                [API_IDS.ZENDESK_JWT_TOKEN]: 'zendesk_jwt_token_api',
                [API_IDS.USER_SUBSCRIPTION_STATUS_NEW]: 'b2c_subscription_status_wcp',
                [API_IDS.MOODS_RECOMMENDATION]: 'moods_recommendation_config',
                [API_IDS.STC_PLAY_GAMES]: 'games_config',
                [API_IDS.THINK_ANALYTICS_API_GET_FEELING_LUCKY]: 'im_feeling_lucky',
                [API_IDS.MPX_GET_CHANNEL_CATEGORIES_API]: 'user_channel_categories_api',
                [API_IDS.MPX_GET_CHANNEL_LIST_BY_CATEGORY_API]: 'user_channel_list_by_category_api',
                [API_IDS.THINK_ANALYTICS_MOOD_VOD_API]: 'get_mood_vod',
                [API_IDS.USER_CDN_API_USER_REVISION]: 'user_revision_information_v1',
                [API_IDS.BOOKMARK_API]: 'users_bookmark_v3',
                [API_IDS.CATCH_UP_EPISODE_LIST]: 'channel_catchup_feed',
                [API_IDS.MIXED_CATCH_UP_EPISODE_LIST]: 'mixed_channel_catchup_feed',
                [API_IDS.CATCH_UP_CAROUSEL_LIST]: 'catchup_carousel_feed',
                [API_IDS.MIXED_CATCH_UP_CAROUSEL_LIST]: 'mixed_catchup_carousel_feed',
                [API_IDS.MPX_GET_ALL_LIST]: 'all_listings_feed',
                [API_IDS.STREAM_HARNESS_ACQUIRE_LOCK]: 'stream_concurrency_lock_v4',
                [API_IDS.STREAM_HARNESS_UNLOCK]: 'stream_concurrency_unlock',
                [API_IDS.STREAM_HARNESS_UNLOCK_J21]: 'stream_concurrency_unlock_j21',
                [API_IDS.LEARN_EVENTS]: 'streaming_learning_actions_ta',
                [API_IDS.USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN]: 'users_otp_request_profiles_v1',
                [API_IDS.USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN_NEW]: 'users_forgot_account_pin_v1',
                [API_IDS.USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN]: 'users_otp_verification_profiles_v1',
                [API_IDS.POPCORN_API_FORGOT_PIN]: 'users_forgot_account_pin',
                [API_IDS.BOOKMARK_API_WATCH_AGAIN]: 'watch_again',
                [API_IDS.LOGOUT_API]: 'LOGOUT_API',
                [API_IDS.PPV_GET_EVENT_CONFIG]: 'get_ppv_event_configs',
                [API_IDS.PPV_GET_COUNTRY_CONFIG]: 'get_ppv_country_configs',
                [API_IDS.PROFILE_AVATER_LIST]: 'profile_avatars',
                [API_IDS.PROFILE_FAVORITE]: 'users_favourite_channels_v3',
                [API_IDS.PPV_PURCHASE_GENERATE_PIN]: 'ppv_purchase_generate_pin',
                [API_IDS.PPV_PURCHASE_VERIFY_PIN]: 'ppv_purchase_verify_pin',
                [API_IDS.GET_PPV_FEED]: 'get_ppv_feed',
                [API_IDS.SLP_QITAF_GENERATE_OTP]: 'ppv_purchase_generate_pin_qitaf',
                [API_IDS.SLP_QITAF_VERIFY_OTP]: 'ppv_purchase_verify_pin_qitaf',
                [API_IDS.REWARD_API_GET_BADGES]: 'get_profile_badge_v1',
                [API_IDS.REWARD_API_GET_QUESTS]: 'get_profile_quests_v1',
                [API_IDS.PPV_PURCHASE_PIN]: 'ppv_purchase_residential',
                [API_IDS.SERIES_HISTORY]: 'series_history',
                [API_IDS.GET_CONTENT_RATING]: 'get_content_rating_ta',
                [API_IDS.B2C_RESET_PASSWORD_GENERATE]: 'b2c_reset_password_generate_j21',
                [API_IDS.B2C_RESET_PASSWORD_VERIFY]: 'b2c_reset_password_verify_j21',
                [API_IDS.MPX_CONTENT_DETAILS]: 'mpx_content_details',
                [API_IDS.SLP_BUNDLE_SAVE_RULES]: 'bundle_and_save_rules',
            };
        default:
            return API_ID_MAP; // Fallback to default mapping
    }
};

export const API_ID_MAP: Record<ApiId, string> = {
    [API_IDS.CONFIG_PAYMENT_CONFIG]: 'CONFIG_PAYMENT_CONFIG',
    [API_IDS.USER_EMAIL_VERIFICATION_GENERATE_PIN]: 'USER_EMAIL_VERIFICATION_GENERATE_PIN',
    [API_IDS.USER_LOCATE_USER]: 'USER_LOCATE_USER',
    [API_IDS.USER_EMAIL_VERIFICATION_VERIFY_PIN]: 'USER_EMAIL_VERIFICATION_VERIFY_PIN',
    [API_IDS.USER_LOGIN_OTP]: 'USER_LOGIN_OTP',
    [API_IDS.USER_LOGIN_STEP_1]: 'USER_LOGIN_STEP_1',
    [API_IDS.USER_LOGIN_CREDENTIALS]: 'USER_LOGIN_CREDENTIALS',
    [API_IDS.USER_LOGIN_WITH_TOKEN]: 'USER_LOGIN_WITH_TOKEN',
    [API_IDS.USER_CHANGE_PASSWORD]: 'USER_CHANGE_PASSWORD',
    [API_IDS.USER_GENERATE_PIN]: 'USER_GENERATE_PIN',
    [API_IDS.USER_VERIFY_PIN]: 'USER_VERIFY_PIN',
    [API_IDS.USER_RESET_PASSWORD_STEP1]: 'USER_RESET_PASSWORD_STEP1',
    [API_IDS.USER_RESET_PASSWORD_STEP2]: 'USER_RESET_PASSWORD_STEP2',
    [API_IDS.USER_GENERATE_PIN_AUTHENTICATED_USER]: 'USER_GENERATE_PIN_AUTHENTICATED_USER',
    [API_IDS.USER_VERIFY_PIN_AUTHENITCATED_USER]: 'USER_VERIFY_PIN_AUTHENITCATED_USER',
    [API_IDS.USER_FORGOT_PASSWORD_GENERATE_PIN_BY_EMAIL]: 'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_EMAIL',
    [API_IDS.USER_FORGOT_PASSWORD_VERIFIY_BY_EMAIL]: 'USER_FORGOT_PASSWORD_VERIFIY_BY_EMAIL',
    [API_IDS.USER_FORGOT_PASSWORD_UPDATE_BY_EMAIL]: 'USER_FORGOT_PASSWORD_UPDATE_BY_EMAIL',
    [API_IDS.USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN]: 'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN',
    [API_IDS.USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN_NEW]: 'USER_FORGOT_PASSWORD_GENERATE_PIN_BY_MSISDN_NEW',
    [API_IDS.USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN]: 'USER_FORGOT_PASSWORD_VERIFIY_BY_MSISDN',
    [API_IDS.USER_FORGOT_PASSWORD_UPDATE_BY_MSISDN]: 'USER_FORGOT_PASSWORD_UPDATE_BY_MSISDN',
    [API_IDS.USER_SUBSCRIPTION_STATUS]: 'USER_SUBSCRIPTION_STATUS',
    [API_IDS.USER_SUBSCRIPTION_STATUS_NEW]: 'USER_SUBSCRIPTION_STATUS_NEW',
    [API_IDS.USER_UNSUBSCRIBE]: 'USER_UNSUBSCRIBE',
    [API_IDS.USER_TPAY_REDIRECT_SUBSCRIBE_NEW_USER]: 'USER_TPAY_REDIRECT_SUBSCRIBE_NEW_USER',
    [API_IDS.USER_TPAY_REDIRECT_SUBSCRIBE_EXISTING_USER]: 'USER_TPAY_REDIRECT_SUBSCRIBE_EXISTING_USER',
    [API_IDS.USER_PARTNER_ACTIVATE_LINK]: 'USER_PARTNER_ACTIVATE_LINK',
    [API_IDS.USER_VERIFY_USER]: 'USER_VERIFY_USER',
    [API_IDS.VERIFY_EMAIL]: 'VERIFY_EMAIL',
    [API_IDS.CONTENT_CHANNELS_MINI_EPG]: 'CONTENT_CHANNELS_MINI_EPG',
    [API_IDS.CONTENT_CHANNELS_ARRIS_STB]: 'CONTENT_CHANNELS_ARRIS_STB',
    [API_IDS.CONTENT_CHANNELS]: 'CONTENT_CHANNELS',
    [API_IDS.CONTENT_CHANNELS_KIDS]: 'CONTENT_CHANNELS_KIDS',
    [API_IDS.CONTENT_CHANNELS_CDN_SCHEDULE]: 'CONTENT_CHANNELS_CDN_SCHEDULE',
    [API_IDS.DEVICE_ADD]: 'DEVICE_ADD',
    [API_IDS.DEVICE_DELETE]: 'DEVICE_DELETE',
    [API_IDS.QR_GENERATE_CODE]: 'QR_GENERATE_CODE',
    [API_IDS.QR_AUTHENTICATE_CODE]: 'QR_AUTHENTICATE_CODE',
    [API_IDS.QR_CODE_LOGIN]: 'QR_CODE_LOGIN',
    [API_IDS.QR_CODE_PAIRING]: 'QR_CODE_PAIRING',
    [API_IDS.QR_CODE_LINK]: 'QR_CODE_LINK',
    [API_IDS.ENTITLEMENT_QITAF_GENERATE_OTP]: 'ENTITLEMENT_QITAF_GENERATE_OTP',
    [API_IDS.ENTITLEMENT_QITAF_TVOD_GENERATE_OTP]: 'ENTITLEMENT_QITAF_TVOD_GENERATE_OTP',
    [API_IDS.ENTITLEMENT_QITAF_VERIFY_OTP]: 'ENTITLEMENT_QITAF_VERIFY_OTP',
    [API_IDS.ENTITLEMENT_QITAF_TVOD_VERIFY_OTP]: 'ENTITLEMENT_QITAF_TVOD_VERIFY_OTP',
    [API_IDS.ENTITLEMENT_ALLOWED_COUNTRIES]: 'ENTITLEMENT_ALLOWED_COUNTRIES',
    [API_IDS.ENTITLEMENT_AVAILABLE_PACKAGES]: 'ENTITLEMENT_AVAILABLE_PACKAGES',
    [API_IDS.ENTITLEMENT_TVODS]: 'ENTITLEMENT_TVODS',
    [API_IDS.ENTITLEMENT_TVOD_PRICING_TEMPLATE]: 'ENTITLEMENT_TVOD_PRICING_TEMPLATE',
    [API_IDS.ENTITLEMENT_ALL]: 'ENTITLEMENT_ALL',
    [API_IDS.ENTITLEMENT_ALL_SUBSCRIPTION_TIERS]: 'ENTITLEMENT_ALL_SUBSCRIPTION_TIERS',
    [API_IDS.ENTITLEMENT_ALL_SUBSCRIPTION_TIERS_V2]: 'ENTITLEMENT_ALL_SUBSCRIPTION_TIERS_V2',
    [API_IDS.ENTITLEMENT_CHANNELS]: 'ENTITLEMENT_CHANNELS',
    [API_IDS.ENTITLEMENT_PROFILE_EPG_CHANNELS]: 'ENTITLEMENT_PROFILE_EPG_CHANNELS',
    [API_IDS.ENTITLEMENT_SUBSCRIBE]: 'ENTITLEMENT_SUBSCRIBE',
    [API_IDS.ENTITLEMENT_TVOD_PURCHASE]: 'ENTITLEMENT_TVOD_PURCHASE',
    [API_IDS.ENTITLEMENT_TVOD_OTP_GENERATE]: 'ENTITLEMENT_TVOD_OTP_GENERATE',
    [API_IDS.ENTITLEMENT_TVOD_OTP_VERIFY]: 'ENTITLEMENT_TVOD_OTP_VERIFY',
    [API_IDS.ENTITLEMENT_PAYMENT_SWITCH_GENERATE_PIN]: 'ENTITLEMENT_PAYMENT_SWITCH_GENERATE_PIN',
    [API_IDS.ENTITLEMENT_PAYMENT_SWITCH_VERIFY_PIN]: 'ENTITLEMENT_PAYMENT_SWITCH_VERIFY_PIN',
    [API_IDS.ENTITLEMENT_NETFLIX_FORGOT_ACCOUNT]: 'ENTITLEMENT_NETFLIX_FORGOT_ACCOUNT',
    [API_IDS.ENTITLEMENT_AMAZON_ACTIVTION_LINK]: 'ENTITLEMENT_AMAZON_ACTIVTION_LINK',
    [API_IDS.ENTITLEMENT_AMAZON_ACCOUNT_RECOVERY]: 'ENTITLEMENT_AMAZON_ACCOUNT_RECOVERY',
    [API_IDS.MPX_ALL_VOD_FEED]: 'MPX_ALL_VOD_FEED',
    [API_IDS.PROFILE_CUD]: 'PROFILE_CUD',
    [API_IDS.PROFILE_LIST]: 'PROFILE_LIST',
    [API_IDS.PROFILE_SWITCH]: 'PROFILE_SWITCH',
    [API_IDS.PROFILE_UPDATE]: 'PROFILE_UPDATE',
    [API_IDS.PROFILE_DELETE]: 'PROFILE_DELETE',
    [API_IDS.PROFILE_ADD]: 'PROFILE_ADD',
    [API_IDS.PROFILE_FAVORITE]: 'PROFILE_FAVORITE',
    [API_IDS.PROFILE_WATCHLIST_VOD]: 'PROFILE_WATCHLIST_VOD',
    [API_IDS.PROFILE_WATCHLIST_LINEAR]: 'PROFILE_WATCHLIST_LINEAR',
    [API_IDS.PROFILE_GET_WATCHLIST]: 'PROFILE_GET_WATCHLIST',
    [API_IDS.PROFILE_CREATE_PARENTAL_PIN]: 'PROFILE_CREATE_PARENTAL_PIN',
    [API_IDS.PROFILE_VALIDATE_PARENTAL_PIN]: 'PROFILE_VALIDATE_PARENTAL_PIN',
    [API_IDS.PROFILE_GET_PARENTAL_PIN]: 'PROFILE_GET_PARENTAL_PIN',
    [API_IDS.PROFILE_UPDATE_PARENTAL_PIN]: 'PROFILE_UPDATE_PARENTAL_PIN',
    [API_IDS.PROFILE_RESET_PARENTAL_PIN_OTP]: 'PROFILE_RESET_PARENTAL_PIN_OTP',
    [API_IDS.PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY]: 'PROFILE_RESET_PARENTAL_PIN_OTP_VERIFY',
    [API_IDS.PROFILE_RESET_PARENTAL_PIN_WITH_OTP]: 'PROFILE_RESET_PARENTAL_PIN_WITH_OTP',
    [API_IDS.PROFILE_VALIDATE_PASSWORD]: 'PROFILE_VALIDATE_PASSWORD',
    [API_IDS.INTERNAL_VERIFY_USER]: 'INTERNAL_VERIFY_USER',
    [API_IDS.ZENDESK_SUBMIT_FORM]: 'ZENDESK_SUBMIT_FORM',
    [API_IDS.CMS_CONFIGURATION]: 'CMS_CONFIGURATION',
    [API_IDS.CMS_LANGUAGE]: 'CMS_LANGUAGE',
    [API_IDS.CMS_SCREEN]: 'CMS_SCREEN',
    [API_IDS.SLP_API_FORM_SIGNATURE]: 'SLP_API_FORM_SIGNATURE',
    [API_IDS.SLP_API_LOGIN_VERIFY]: 'SLP_API_LOGIN_VERIFY',
    [API_IDS.SLP_API_LOGIN_CREDENTIALS]: 'SLP_API_LOGIN_CREDENTIALS',
    [API_IDS.SLP_API_LOGIN_OTP]: 'SLP_API_LOGIN_OTP',
    [API_IDS.ENTITLEMENT_ADDON_PURCHASE]: 'ENTITLEMENT_ADDON_PURCHASE',
    [API_IDS.SLP_API_FORGOT_PASSWORD_SEND_OTP]: 'SLP_API_FORGOT_PASSWORD_SEND_OTP',
    [API_IDS.SLP_API_FORGOT_PASSWORD_RESEND_OTP]: 'SLP_API_FORGOT_PASSWORD_RESEND_OTP',
    [API_IDS.SLP_API_FORGOT_PASSWORD_VERIFY_OTP]: 'SLP_API_FORGOT_PASSWORD_VERIFY_OTP',
    [API_IDS.SLP_API_FORGOT_PASSWORD_RESET]: 'SLP_API_FORGOT_PASSWORD_RESET',
    [API_IDS.POPCORN_API_FORGOT_PIN]: 'POPCORN_API_FORGOT_PIN',
    [API_IDS.SLP_API_VERIFY_QR_CODE]: 'SLP_API_VERIFY_QR_CODE',
    [API_IDS.USER_CDN_API_USER_REVISION]: 'USER_CDN_API_USER_REVISION',
    [API_IDS.AUTO_LOGIN]: 'AUTO_LOGIN',
    [API_IDS.AUTH_REFRESH_TOKEN]: 'AUTH_REFRESH_TOKEN',
    [API_IDS.REMINDER_API_SET_REMINDER]: 'REMINDER_API_SET_REMINDER',
    [API_IDS.REMINDER_API_UNSET_REMINDER]: 'REMINDER_API_UNSET_REMINDER',
    [API_IDS.REMINDER_VOD_API_LIST_REMINDER]: 'REMINDER_VOD_API_LIST_REMINDER',
    [API_IDS.REMINDER_LINIER_API_LIST_REMINDER]: 'REMINDER_LINIER_API_LIST_REMINDER',
    [API_IDS.REMINDER_PPV_API_LIST_REMINDER]: 'REMINDER_PPV_API_LIST_REMINDER',
    [API_IDS.REMINDER_LIST]: 'REMINDER_LIST',
    [API_IDS.SLP_API_AMAZON_ACTIVATE]: 'SLP_API_AMAZON_ACTIVATE',
    [API_IDS.ZENDESK_JWT_TOKEN]: 'ZENDESK_JWT_TOKEN',
    [API_IDS.ZENDESK_JWT_TOKEN_CLASSIC]: 'ZENDESK_JWT_TOKEN_CLASSIC',
    [API_IDS.DEVICE_PAIRING]: 'DEVICE_PAIRING',
    [API_IDS.BOOKMARK_API]: 'users_bookmark_v3',
    [API_IDS.GEO_LOCATION_API_GET_MY_LOCATION]: 'GEO_LOCATION_API_GET_MY_LOCATION',
    [API_IDS.POPCORN_API_GET_ALL_PROMOTIONS]: 'POPCORN_API_GET_ALL_PROMOTIONS',
    [API_IDS.POPCORN_API_GET_ALL_REWIND]: 'POPCORN_API_GET_ALL_REWIND',
    [API_IDS.DISCOUNT_API_VALIDATE_GIFT_CARD]: 'DISCOUNT_API_VALIDATE_GIFT_CARD',
    [API_IDS.DISCOUNT_API_SUBSCRIBE_BY_GIFT_CARD]: 'DISCOUNT_API_SUBSCRIBE_BY_GIFT_CARD',
    [API_IDS.DISCOUNT_API_RESUBSCRIBE_BY_GIFT_CARD]: 'DISCOUNT_API_RESUBSCRIBE_BY_GIFT_CARD',
    [API_IDS.DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE]: 'DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE',
    [API_IDS.DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE_VERIFY]: 'DISCOUNT_API_GIFT_CARD_USER_RESUBSCRIBE_VERIFY',
    [API_IDS.CHANNELS_HISTORY]: 'CHANNELS_HISTORY',
    [API_IDS.CHANNEL_INFO]: 'CHANNEL_INFO',
    [API_IDS.SERIES_HISTORY]: 'SERIES_HISTORY',
    [API_IDS.PROFILE_WATCH_HISTORY]: 'PROFILE_WATCH_HISTORY',
    [API_IDS.THINK_ANALYTICS_API_GET_VOD_LIST]: 'THINK_ANALYTICS_API_GET_VOD_LIST',
    [API_IDS.GATEWAY_CONFIGURATION]: 'GATEWAY_CONFIGURATION',
    [API_IDS.GATEWAY_LANGUAGE_EN]: 'GATEWAY_LANGUAGE_EN',
    [API_IDS.GATEWAY_LANGUAGE_AR]: 'GATEWAY_LANGUAGE_AR',
    [API_IDS.GATEWAY_SCREEN]: 'GATEWAY_SCREEN',
    [API_IDS.THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED]: 'THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED',
    [API_IDS.THINK_ANALYTICS_API_GET_RELATED]: 'THINK_ANALYTICS_API_GET_RELATED',
    [API_IDS.THINK_ANALYTICS_API_GET_RELATED_OTHERS]: 'THINK_ANALYTICS_API_GET_RELATED_OTHERS',
    [API_IDS.BOOKMARK_API_WATCH_AGAIN]: 'BOOKMARK_API_WATCH_AGAIN',
    [API_IDS.THINK_ANALYTICS_API_SEARCH_SUGGESTIONS]: 'THINK_ANALYTICS_API_SEARCH_SUGGESTIONS',
    [API_IDS.THINK_ANALYTICS_API_SEARCH_PA]: 'THINK_ANALYTICS_API_SEARCH_PA',
    [API_IDS.CONTENT_LIKE_DISLIKE_RATING]: 'CONTENT_LIKE_DISLIKE_RATING',
    [API_IDS.SLP_COUNTRY_CONFIGS]: 'SLP_COUNTRY_CONFIGS',
    [API_IDS.RESUBSCRIBE_OTP_SEND]: 'RESUBSCRIBE_OTP_SEND',
    [API_IDS.RESUBSCRIBE_OTP_VERIFY]: 'RESUBSCRIBE_OTP_VERIFY',
    [API_IDS.PAYMENT_SWITCH_GENERATE]: 'PAYMENT_SWITCH_GENERATE',
    [API_IDS.PAYMENT_SWITCH_VERIFY]: 'PAYMENT_SWITCH_VERIFY',
    [API_IDS.RESUBSCRIBE_CREDIT_CARD]: 'RESUBSCRIBE_CREDIT_CARD',
    [API_IDS.SLP_BUNDLE_SAVE]: 'SLP_BUNDLE_SAVE',
    [API_IDS.SLP_BUNDLE_SAVE_INFO]: 'SLP_BUNDLE_SAVE_INFO',
    [API_IDS.SLP_BUNDLE_SAVE_RULES]: 'SLP_BUNDLE_SAVE_RULES',
    [API_IDS.ACTIVE_SUB_VOUCHER]: 'ACTIVE_SUB_VOUCHER',
    [API_IDS.SLP_BOLT_SUBSCRIPTION]: 'SLP_BOLT_SUBSCRIPTION',
    [API_IDS.SLP_BOLT_SUBSCRIPTION_TWO_STEPS]: 'SLP_BOLT_SUBSCRIPTION_TWO_STEPS',
    [API_IDS.SLP_BOLT_VERIFICATION_TWO_STEPS]: 'SLP_BOLT_VERIFICATION_TWO_STEPS',
    [API_IDS.SLP_QITAF_GENERATE_OTP]: 'SLP_QITAF_GENERATE_OTP',
    [API_IDS.SLP_QITAF_VERIFY_OTP]: 'SLP_QITAF_VERIFY_OTP',
    [API_IDS.LEARN_ACTION_SET_PREFERENCES]: 'LEARN_ACTION_SET_PREFERENCES',
    [API_IDS.SEARCH_ACTION_CLICK]: 'SEARCH_ACTION_CLICK',
    [API_IDS.LEARN_EVENTS]: 'LEARN_EVENTS',
    [API_IDS.THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE]: 'THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE',
    [API_IDS.SLP_USER_REGISTRATION]: 'SLP_USER_REGISTRATION',
    [API_IDS.SLP_USER_REGISTRATION_GENERATE_PIN]: 'SLP_USER_REGISTRATION_GENERATE_PIN',
    [API_IDS.SLP_USER_REGISTRATION_VERIFY_PIN]: 'SLP_USER_REGISTRATION_VERIFY_PIN',
    [API_IDS.NOTIFICATIONS_VALIDATE_VOC_TOKEN]: 'NOTIFICATIONS_VALIDATE_VOC_TOKEN',
    [API_IDS.SLP_LEGACY_CC_MIGRATE]: 'SLP_LEGACY_CC_MIGRATE',
    [API_IDS.SLP_LEGACY_DCB_MIGRATE_GENERATE]: 'SLP_LEGACY_DCB_MIGRATE_GENERATE',
    [API_IDS.SLP_LEGACY_DCB_MIGRATE_VERIFY]: 'SLP_LEGACY_DCB_MIGRATE_VERIFY',
    [API_IDS.GET_PROVIDERS]: 'GET_PROVIDERS',
    [API_IDS.GET_FOOTER_MENU_CONTENT]: 'GET_FOOTER_MENU_CONTENT',
    [API_IDS.GET_ITEM_BY_ID]: 'GET_ITEM_BY_ID',
    [API_IDS.GET_CAST_CREW]: 'GET_CAST_CREW',
    [API_IDS.GET_ALL_SEASONS]: 'GET_ALL_SEASONS',
    [API_IDS.GET_ALL_EPISODES]: 'GET_ALL_EPISODES',
    [API_IDS.USER_CONSENT_API]: 'USER_CONSENT_API',
    [API_IDS.GET_HEADER_MENU_CONTENT]: 'GET_HEADER_MENU_CONTENT',
    [API_IDS.RBO_RESUB]: 'RBO_RESUB',
    [API_IDS.RBO_RESUB_VERIFY]: 'RBO_RESUB_VERIFY',
    [API_IDS.MPX_BIOGRAPHY]: 'MPX_BIOGRAPHY',
    [API_IDS.MPX_FILMOGRAPHY]: 'MPX_FILMOGRAPHY',
    [API_IDS.CHANNELS]: 'CHANNELS',
    [API_IDS.POPCORN_GET_ALL_REWIND_MOVIES]: 'POPCORN_GET_ALL_REWIND_MOVIES',
    [API_IDS.CATCH_UP_EPISODE_LIST]: 'CATCH_UP_EPISODE_LIST',
    [API_IDS.MIXED_CATCH_UP_EPISODE_LIST]: 'MIXED_CATCH_UP_EPISODE_LIST',
    [API_IDS.CATCH_UP_CAROUSEL_LIST]: 'CATCH_UP_CAROUSEL_LIST',
    [API_IDS.MIXED_CATCH_UP_CAROUSEL_LIST]: 'MIXED_CATCH_UP_CAROUSEL_LIST',
    [API_IDS.MOODS_RECOMMENDATION]: 'MOODS_RECOMMENDATION',
    [API_IDS.STC_PLAY_GAMES]: 'STC_PLAY_GAMES',
    [API_IDS.THINK_ANALYTICS_API_GET_FEELING_LUCKY]: 'THINK_ANALYTICS_API_GET_FEELING_LUCKY',
    [API_IDS.MPX_GET_CHANNEL_CATEGORIES_API]: 'MPX_GET_CHANNEL_CATEGORIES_API',
    [API_IDS.MPX_GET_CHANNEL_LIST_BY_CATEGORY_API]: 'MPX_GET_CHANNEL_LIST_BY_CATEGORY_API',
    [API_IDS.THINK_ANALYTICS_MOOD_VOD_API]: 'THINK_ANALYTICS_MOOD_VOD_API',
    [API_IDS.MPX_GET_ALL_LIST]: 'MPX_GET_ALL_LIST',
    [API_IDS.STREAM_HARNESS_ACQUIRE_LOCK]: 'STREAM_HARNESS_ACQUIRE_LOCK',
    [API_IDS.STREAM_HARNESS_UNLOCK]: 'STREAM_HARNESS_UNLOCK',
    [API_IDS.STREAM_HARNESS_UNLOCK_J21]: 'STREAM_HARNESS_UNLOCK_J21',
    [API_IDS.LOGOUT_API]: 'LOGOUT_API',
    [API_IDS.PPV_GET_EVENT_CONFIG]: 'PPV_GET_EVENT_CONFIG',
    [API_IDS.PPV_GET_COUNTRY_CONFIG]: 'PPV_GET_COUNTRY_CONFIG',
    [API_IDS.PPV_PURCHASE]: 'PPV_PURCHASE',
    [API_IDS.PPV_PURCHASE_GENERATE_PIN]: 'PPV_PURCHASE_GENERATE_PIN',
    [API_IDS.PPV_PURCHASE_VERIFY_PIN]: 'PPV_PURCHASE_VERIFY_PIN',
    [API_IDS.PROFILE_AVATER_LIST]: 'PROFILE_AVATER_LIST',
    [API_IDS.REWARD_API_GET_BADGES]: 'REWARD_API_GET_BADGES',
    [API_IDS.REWARD_API_GET_QUESTS]: 'REWARD_API_GET_QUESTS',
    [API_IDS.CAMPAIGN_GENERATE]: 'CAMPAIGN_GENERATE',
    [API_IDS.CAMPAIGN_VERIFY]: 'CAMPAIGN_VERIFY',
    [API_IDS.GET_PPV_FEED]: 'GET_PPV_FEED',
    [API_IDS.CHECK_USER]: 'CHECK_USER',
    [API_IDS.PPV_PURCHASE_PIN]: 'PPV_PURCHASE_PIN',
    [API_IDS.SUBSCRIPTION_VALIDATE_ACTIVATION_LINK]: 'SUBSCRIPTION_VALIDATE_ACTIVATION_LINK',
    [API_IDS.SUBSCRIPTION_DISNEY_GENERATE_OTP]: 'SUBSCRIPTION_DISNEY_GENERATE_OTP',
    [API_IDS.SUBSCRIPTION_DISNEY_VALIDATE_OTP]: 'SUBSCRIPTION_DISNEY_VALIDATE_OTP',
    [API_IDS.SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK]: 'SUBSCRIPTION_DISNEY_REQUEST_ACTIVATION_LINK',
    [API_IDS.FORGET_PIN_RESEND]: 'FORGET_PIN_RESEND',
    [API_IDS.GET_CONTENT_RATING]: 'GET_CONTENT_RATING',
    [API_IDS.B2C_RESET_PASSWORD_GENERATE]: 'B2C_RESET_PASSWORD_GENERATE',
    [API_IDS.B2C_RESET_PASSWORD_VERIFY]: 'B2C_RESET_PASSWORD_VERIFY',
    [API_IDS.MPX_CONTENT_DETAILS]: 'MPX_CONTENT_DETAILS',
};
